// @flow

import _ from 'lodash';
import ko from 'rgs-knockout';

import bytes from 'bytes';

import { JSable } from 'jsable';

import type { Observable } from 'rgs-knockout';

export interface ITemporaryFileInfo {
	ID: string;
	CassandraID: Observable<string>;
	Name: Observable<string>;
	Size: Observable<number>;
	Upload: Observable<string>;
}

class TemporaryFileInfo extends JSable implements ITemporaryFileInfo {

	constructor () {
		super();

		this.ID = null;

		this.CassandraID = ko.observable()
			.extend({ toFromJS: true });

		this.Name = ko.observable()
			.extend({ toFromJS: true })
			.extend({ repr: _.identity });

		this.Size = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				repr: b => bytes.format(b),
			});

		this.Upload = {
			State: ko.oneOf([
				'pending',
				'fulfilled',
				'rejected',
			])
				.extend({
					repr: (v) => ({
						pending: 'Загружается...',
						fulfilled: 'Загружен',
						rejected: 'Ошибка загрузки',
					}[v]),
				}),
		};
	}

	toJS () {
		return _.extend(super.toJS(), {
			ID: this.ID,
		});
	}
}

export { TemporaryFileInfo };
